export default __webpack_public_path__ + "static/media/cleo_payku.71d77fe3.webp";